import { AntDesign, MaterialCommunityIcons } from "@expo/vector-icons";
import {
  Card,
  ProductThumbnail,
  Text,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import React from "react";
import { Pressable } from "react-native";
import { Colors, Spacings, View } from "react-native-ui-lib";

export interface NonProductSummaryCardProps {
  barcode: string;
  onPress?: () => void;
}

const NON_PRODUCT_HEADER = "Non-Matched Product";

export const NonProductSummaryCard = ({
  barcode,
  onPress,
}: NonProductSummaryCardProps) => {
  const { colors } = useThemeProvider();

  const Wrapper = onPress
    ? (props: { children?: React.ReactNode }) => (
        <Pressable {...props} onPress={onPress} />
      )
    : View;

  const rightComponent = onPress ? (
    <AntDesign
      style={[{ marginLeft: Spacings.s4 }]}
      name="right"
      size={24}
      color={Colors.text}
    />
  ) : undefined;

  const thumbnailIconMarkup = (
    <MaterialCommunityIcons
      name="barcode"
      size={24}
      color={colors.iconSubdued}
    />
  );

  return (
    <Card
      filled={false}
      style={{
        backgroundColor: colors.backgroundWarning,
        borderColor: colors.borderWarning,
      }}
      flex
    >
      <Wrapper
        style={{
          display: "flex",
          borderRadius: 8,
        }}
      >
        <View
          flex
          row
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <View
            style={{ alignItems: "center", flexBasis: "100%", flexShrink: 1 }}
            row
          >
            <ProductThumbnail
              hideQuantity
              placeholderIcon={thumbnailIconMarkup}
              isInternalProduct={false}
              size="large"
            />
            <View marginL-20 style={{ flexShrink: 1 }}>
              <Text variant="heading1" numberOfLines={1} ellipsizeMode="head">
                {NON_PRODUCT_HEADER}
              </Text>
              <Text>Click here to create product</Text>
              <View row>
                <Text fontWeight="bold">Stock Number: </Text>
                <Text color="subdued">{barcode}</Text>
              </View>
            </View>
          </View>
          {rightComponent}
        </View>
      </Wrapper>
    </Card>
  );
};
